import React, { Component } from "react";

const customers = [
  { name: "A D Publication", logo: "assets/img/clients/ADPublication.png" },
  { name: "CIHM", logo: "assets/img/clients/CIHM.png" },
  { name: "Comet Chemicals", logo: "assets/img/clients/Commet-Chemicals.png" },
  { name: "ECD", logo: "assets/img/clients/ECD.jpg" },
  { name: "ECO Build", logo: "assets/img/clients/ECO Build.png" },
  { name: "Gudfynd", logo: "assets/img/clients/Gudfynd.png" },
  { name: "Life Lab Care", logo: "assets/img/clients/LifeLabCare.jpeg" },
  { name: "Micronics", logo: "assets/img/clients/Micronics.WEBP" },
  { name: "Montdor interior", logo: "assets/img/clients/Final-logo.png" },
  { name: "Neev Organic Haat", logo: "assets/img/clients/NeevOrganicHaat.png" },
  { name: "PMET", logo: "assets/img/clients/PMET.png" },
  { name: "Shreenathji Corporation LLP", logo: "assets/img/clients/ShreenathjiCorp.png" },
  { name: "SR Design", logo: "assets/img/clients/SRDesign.png" },
  { name: "STPL", logo: "assets/img/clients/STPL.JPEG" },
];

class Customers extends Component {
  state = {
    index: 0,
    visibleCount: 4,
  };

  componentDidMount() {
    this.updateVisibleCount();
    window.addEventListener("resize", this.updateVisibleCount);
    this.timer = setInterval(this.nextSlide, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    window.removeEventListener("resize", this.updateVisibleCount);
  }

  updateVisibleCount = () => {
    const width = window.innerWidth;
    let visibleCount = 4;
    if (width < 992) visibleCount = 2; // tablet
    if (width < 576) visibleCount = 1; // mobile
    this.setState({ visibleCount, index: 0 });
  };

  nextSlide = () => {
    const { index, visibleCount } = this.state;
    const maxIndex = customers.length - visibleCount;
    this.setState({ index: index >= maxIndex ? 0 : index + 1 });
  };

  goToSlide = (slideIndex) => {
    this.setState({ index: slideIndex });
  };

  render() {
    const { index, visibleCount } = this.state;
    const itemWidth = 100 / visibleCount;
    const totalSlides = customers.length - visibleCount + 1;

    // Calculate dots (max 5)
    const maxDots = 5;
    const dotsCount = Math.min(maxDots, totalSlides);
    const step = totalSlides / dotsCount;

    const activeDot = Math.floor(index / step);

    return (
      <section id="customers" className="customers">
        <div className="container">
          <div className="section-title" data-aos="fade-up">
            <h2>Our Customers</h2>
          </div>

          {/* Slider */}
          <div style={{ overflow: "hidden", width: "100%" }}>
            <div
              style={{
                display: "flex",
                transition: "transform 0.6s ease",
                transform: `translateX(-${index * itemWidth}%)`,
              }}
            >
              {customers.map((customer, i) => (
                <div
                  key={i}
                  style={{
                    flex: `0 0 ${itemWidth}%`,
                    padding: "20px",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                >
                  <div>
                    <div
                      style={{
                        height: "130px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <img
                        src={customer.logo}
                        alt={customer.name}
                        style={{
                          maxHeight: "120px",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333",
                        lineHeight: "1.2",
                      }}
                    >
                      {customer.name}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            {Array.from({ length: dotsCount }).map((_, dotIndex) => (
              <span
                key={dotIndex}
                onClick={() => this.goToSlide(Math.round(dotIndex * step))}
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  backgroundColor: dotIndex === activeDot ? "#007bff" : "#ccc",
                  transition: "0.3s",
                }}
              />
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default Customers;
